export enum HomesTypes {
  All = 'All',
  VacationRentalOnly = 'VacationRentalOnly',
  HotelOnly = 'HotelOnly'
}
